/**
 * Слайдер похожих товаров
 */

class Similar {
    constructor(el) {
        this.container = el;
        this.slider = this.container.querySelector('.js-similar-swiper');

        this.initSlider();
    }

    initSlider() {
        this.swiper = new Swiper(this.slider, {
            loop: false,
            slidesPerView: 2,
            spaceBetween: 16,
            threshold: 10,
            roundLengths: true,
            speed: 700,
            watchOverflow: true,
            watchSlidesVisibility: true,
            a11y: true,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 1,
                loadOnTransitionStart: true
            },
            breakpoints: {
                768: {
                    slidesPerView: 2.5,
                },
                1000: {
                    slidesPerView: 3,
                }
            },
            navigation: {
                prevEl: this.container.querySelector('.js-slider-prev'),
                nextEl: this.container.querySelector('.js-slider-next'),
                disabledClass: '_is-disabled'
            },
        });
    }
}

document.querySelectorAll('.js-similar').forEach(el => {
    new Similar(el);
});



// WEBPACK FOOTER //
// ./_src/js/Similar.js